import type { RichBlock, RichInline } from './types';

/**
 * Flatten rich blocks back to plain text — for previews (launcher teaser,
 * monitor row), notifications, and anywhere the markup would show as noise.
 * Blocks are joined with a single space so a preview stays on one line.
 */
export function richTextToPlain(blocks: RichBlock[]): string {
  return blocks.map(blockToPlain).filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
}

function blockToPlain(block: RichBlock): string {
  switch (block.kind) {
    case 'paragraph':
    case 'heading':
      return inlineToPlain(block.children);
    case 'list':
      return block.items.map((item) => item.map(blockToPlain).join(' ')).join(' · ');
    case 'codeblock':
      return block.text;
    case 'quote':
      return block.children.map(blockToPlain).join(' ');
    case 'rule':
      return '';
  }
}

function inlineToPlain(nodes: RichInline[]): string {
  return nodes
    .map((n) => {
      switch (n.kind) {
        case 'text':
          return n.text;
        case 'br':
          return ' ';
        case 'code':
          return n.text;
        case 'strong':
        case 'em':
        case 'link':
          return inlineToPlain(n.children);
      }
    })
    .join('');
}
